import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { getApex } from '../../apex';
import { getQueryParam } from '../../helpers/queryParamsHelper';
import { showSnack } from './snackbarActions';
export var SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export var SIGNUP_ERROR = 'SIGNUP_ERROR';
export var SIGNUP_REQUESTED = 'SIGNUP_REQUESTED';
export var CLEAR_SIGNUP_ERROR = 'CLEAR_SIGNUP_ERROR';
var signup = function signup(payload) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var username, email, password, matchingPassword, additionalFields, AffiliateTag, userConfig, field, apex, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              username = payload.username, email = payload.email, password = payload.password, matchingPassword = payload.matchingPassword, additionalFields = _objectWithoutProperties(payload, ['username', 'email', 'password', 'matchingPassword']);
              AffiliateTag = payload.AffiliateTag;
              dispatch(signupRequested);
              if (window.location.search) {
                AffiliateTag = getQueryParam('aff');
              } else {
                AffiliateTag = window.localStorage.getItem('affiliateTag');
              }
              userConfig = [];
              for (field in additionalFields) {
                userConfig.push({
                  Name: field,
                  Value: additionalFields[field]
                });
              }
              apex = void 0;
              _context.prev = 7;
              apex = getApex();
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](7);
              return _context.abrupt('return', dispatch(showSnack({
                id: 'signupError',
                text: _context.t0.message,
                type: 'warning'
              })));
            case 14:
              _context.next = 16;
              return apex.connection.RegisterNewUser({
                UserInfo: {
                  UserName: username || email,
                  passwordHash: password,
                  Email: email
                },
                UserConfig: userConfig,
                AffiliateTag: AffiliateTag,
                OperatorId: 1
              });
            case 16:
              response = _context.sent;
              if (!response.UserId) {
                _context.next = 21;
                break;
              }
              dispatch(signupSuccess(response.UserId));
              _context.next = 22;
              break;
            case 21:
              return _context.abrupt('return', response);
            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[7, 11]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export { signup };
export var signupRequested = {
  type: SIGNUP_REQUESTED,
  payload: {
    requesting: true
  }
};
export var signupSuccess = function signupSuccess(userId) {
  return {
    type: SIGNUP_SUCCESS,
    payload: {
      userId: userId,
      requesting: false
    }
  };
};
export var signupError = function signupError(payload) {
  return {
    type: SIGNUP_ERROR,
    payload: {
      errorMsg: payload.errormsg,
      requesting: false
    }
  };
};
export var clearSignupError = function clearSignupError() {
  return {
    type: CLEAR_SIGNUP_ERROR
  };
};